import React, { ImgHTMLAttributes } from 'react';
import styled from 'styled-components';

interface ImageIconProps extends ImgHTMLAttributes<HTMLImageElement> {
  src?: string;
  alt?: string;
}

const ImageIcon: React.FC<ImageIconProps> = ({ src, alt = 'icon', ...props }) => {
  return <Image src={src} alt={alt} role="img" {...props} />;
};

export default ImageIcon;

const Image = styled.img`
  -webkit-user-select: none; /* Safari */
  user-select: none;
  pointer-events: none;
  cursor: auto;
`;
